module.exports = __webpack_public_path__ + "img/区块链司法存证ico.3dc4fa96.png";